import * as React from 'react';
import clsx from 'clsx';
import {
    IFilter,
    IFilterListText
} from 'services/containers/containers-service';
import { OneCheckboxFilterItem } from './one-checkbox-item';

export interface IInfrastructureFilterProps {
    filters: IFilter[];
    title: string;
    onFilterChage: (new_filter: IFilterListText) => any;
    className?: string;
    HAS_WATER_FILTER_ID?: number;
    HAS_DRAINAGE_FILTER_ID?: number;
    HAS_ELECTRICITY_FILTER_ID?: number;
    HAS_OIL_FILTER_ID?: number;
    HAS_HEAT_FILTER_ID?: number;
}
export interface IInfrastructureFilterState {}

/* eslint-disable */
class InfrastructureFilterComponent extends React.Component<
    IInfrastructureFilterProps, 
    IInfrastructureFilterState
> {
/* eslint-enable */

    constructor(props: IInfrastructureFilterProps) {
        super(props);
    }

    render() {
        let { filters } = this.props;

        const {
            /** Наличие водоснабжения */
            HAS_WATER_FILTER_ID = 27,
            /** Наличие водоотведения */
            HAS_DRAINAGE_FILTER_ID = 28,
            /** Наличие электроснабжения */
            HAS_ELECTRICITY_FILTER_ID = 29,
            /** Наличие газоснабжения */
            HAS_OIL_FILTER_ID = 30,
            /** Наличие теплоснабжения */
            HAS_HEAT_FILTER_ID = 31
        } = this.props;

        let hasWaterFilter = filters.find(f => f.id === HAS_WATER_FILTER_ID) as IFilterListText;
        let hasDrainageFilter = filters.find(f => f.id === HAS_DRAINAGE_FILTER_ID) as IFilterListText;
        let hasElectricityFilter = filters.find(f => f.id === HAS_ELECTRICITY_FILTER_ID) as IFilterListText;
        let hasOilFilter = filters.find(f => f.id === HAS_OIL_FILTER_ID) as IFilterListText;
        let hasHeatFilter = filters.find(f => f.id === HAS_HEAT_FILTER_ID) as IFilterListText;

        return (
            <div className={clsx('infrastructure-filter-wrapper', this.props.className)}>
                <div className="filter-title">
                    { this.props.title }
                </div>
                <OneCheckboxFilterItem
                    filter={hasWaterFilter}
                    onFilterChange={this.props.onFilterChage}
                />
                <OneCheckboxFilterItem
                    filter={hasDrainageFilter}
                    onFilterChange={this.props.onFilterChage}
                />
                <OneCheckboxFilterItem
                    filter={hasElectricityFilter}
                    onFilterChange={this.props.onFilterChage}
                />
                <OneCheckboxFilterItem
                    filter={hasOilFilter}
                    onFilterChange={this.props.onFilterChage}
                />
                <OneCheckboxFilterItem
                    filter={hasHeatFilter}
                    onFilterChange={this.props.onFilterChage}
                />
            </div>
        );
    }
}

export const InfrastructureFilter = InfrastructureFilterComponent;
